import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { fallback, number, object, optional, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/admin/devtools/listing-selector")({
  component: lazyRouteComponent(() => import("./+ListingSelector")),
  validateSearch: object({
    "page-size": fallback(pipe(optional(number(), 10), toMinValue(10)), 10),
  }),
  head: () => ({ meta: seo({ title: "Listing Selector" }) }),
});
